var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8LogicProX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M34.133,3.965L8.084,8.091c-1.091,0.173-1.835,1.197-1.663,2.288l5.058,31.934 c0.173,1.091,1.197,1.835,2.288,1.663l26.049-4.126c1.091-0.173,1.835-1.197,1.663-2.288L36.421,5.628 C36.248,4.537,35.224,3.793,34.133,3.965z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M9.385,9.91l24.072-3.813c0.545-0.086,1.058,0.286,1.144,0.831l4.746,29.958 c0.086,0.545-0.286,1.058-0.831,1.144l-24.072,3.813c-0.545,0.086-1.058-0.286-1.144-0.831L8.553,11.054 C8.467,10.509,8.839,9.997,9.385,9.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M34.108,20.903c0,5.8-4.7,10.5-10.5,10.5c-1.79,0-3.48-0.45-4.95-1.24 c-1.83-0.98-3.33-2.48-4.31-4.31c-0.79-1.47-1.24-3.16-1.24-4.95c0-5.8,4.7-10.5,10.5-10.5c1.79,0,3.48,0.45,4.95,1.24 c1.83,0.98,3.33,2.48,4.31,4.31C33.658,17.422,34.108,19.112,34.108,20.903z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M27.108,20.903c0,1.93-1.57,3.5-3.5,3.5c-0.6,0-1.16-0.15-1.65-0.41c-0.61-0.33-1.11-0.83-1.44-1.44 c-0.26-0.49-0.41-1.05-0.41-1.65c0-1.93,1.57-3.5,3.5-3.5c0.6,0,1.16,0.15,1.65,0.41c0.61,0.33,1.11,0.83,1.44,1.44 C26.958,19.742,27.108,20.302,27.108,20.903z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.816,
    height: 4.276,
    x: 21.382,
    y: 33.644,
    fill: "#eceff1",
    transform: "rotate(-8.996 26.298 35.789)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M21.958,23.992l-3.3,6.17c-1.83-0.98-3.33-2.48-4.31-4.31l6.17-3.3 C20.848,23.163,21.348,23.663,21.958,23.992z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M23.608,20.903l-1.65,3.09c-0.61-0.33-1.11-0.83-1.44-1.44L23.608,20.903z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M32.868,15.952l-6.17,3.3c-0.33-0.61-0.83-1.11-1.44-1.44l3.3-6.17 C30.388,12.622,31.888,14.122,32.868,15.952z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M26.698,19.252l-3.09,1.65l1.65-3.09C25.868,18.142,26.368,18.642,26.698,19.252z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.608,
    cy: 20.903,
    r: 0.5,
    fill: "#37474f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LogicProX);
export default __webpack_public_path__ + "static/media/icons8-logic-pro-x.9c3ba32e33685289fd50f472e05038ed.svg";
export { ForwardRef as ReactComponent };